<template>
    <PageContent slug="terms" />
</template>

<script setup>
import PageContent from './PageContent.vue'
</script>

